import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'
import scrollLock from 'scroll-lock';

import './ApplicationPopup.css'

var ApplicationPopup = Backbone.View.extend({
    el: '.ApplicationPopup',

    events: {
        'click .ApplicationPopup-close button': 'onClose',
        'input .ApplicationPopup-input': 'onInput',
        'blur .ApplicationPopup-input': 'onBlur',
        'click .ApplicationPopup-button': 'onSubmit',
        'click .ApplicationPopup-overlay': 'onClose'
    },

    initialize () {
        _.bindAll(this, 'activate', 'deactivate', 'onClose', 'onInput', 'onSubmit', 'onSuccess', 'onFailure', 'onBlur');

        this.$popup = this.$('.ApplicationPopup-popup');
        this.$overlay = this.$('.ApplicationPopup-overlay');
        this.$inputs = this.$('.ApplicationPopup-input');
        this.$button = this.$('.ApplicationPopup-button');
        this.$loader = this.$('.ApplicationPopup-loader');
        this.$failure = this.$('.ApplicationPopup-failure');
        this.$success = this.$('.ApplicationPopup-success');

        $("textarea").each(function () {
            this.setAttribute("style", "overflow-y:hidden;");
        }).on("input", function () {
            this.style.height = 0;
            this.style.height = (this.scrollHeight) + "px";
        });
    },

    onBlur (event) {
        var inputValue = event.target.value;
        var required = event.target.required;

        if (!required) {
            return;
        }

        !inputValue && $(event.target).toggleClass('isInvalid', true);
    },

    onSuccess () {
        this.$success.css('display', 'block');
        this.$failure.css('display', 'none');
        this.$loader.css('display', 'none');
        this.$button.css('display', 'none');
        this.$button.toggleClass('isDisabled', false);
        this.$inputs.toggleClass('isDisabled', true);
    },

    onFailure () {
        this.$success.css('display', 'none');
        this.$failure.css('display', 'block');
        this.$loader.css('display', 'none');
        this.$button.css('display', 'block');

        this.$button.toggleClass('isDisabled', false);
        this.$inputs.toggleClass('isDisabled', false);
    },

    onSubmit (event) {
        event.preventDefault();
        event.stopPropagation();

        var isValid = !this.$button.hasClass('isDisabled');

        if (!isValid) {
            return;
        }

        this.$success.css('display', 'none');
        this.$failure.css('display', 'none');
        this.$button.toggleClass('isDisabled', true);
        this.$loader.css('display', 'block');
        this.$inputs.toggleClass('isDisabled', true);

        var data = {}

        for (var i = 0; i < this.$inputs.length; i++) {
            var input = this.$inputs[i];
            var value = input && input.value;
            var name = input && input.name;

            data[name] = value;
        }

        $.ajax({
            url: '/api/application/',
            type: "POST",
            data: JSON.stringify(data),
            contentType: 'application/json',
            success: this.onSuccess.bind(this),
            error: this.onFailure.bind(this)
        });
    },

    onInput (event) {
        $(event.target).toggleClass('isInvalid', false);
        var isValid = true;

        for (var i = 0; i < this.$inputs.length; i++) {
            var input = this.$inputs[i];
            var required = !!$(input).attr('required');

            if (!required) {
                continue;
            }

            var value = input.value;

            if (value) {
                continue;
            }

            isValid = false;
        }

        this.$button.toggleClass('isDisabled', !isValid);
    },

    onClose () {
        app.views.applicationPopup.deactivate();
    },

    activate (options) {
        scrollLock.disablePageScroll();

        $.Velocity.hook(this.$popup, 'opacity', '0');
        $.Velocity.hook(this.$popup, 'translateY', '-40%');
        $.Velocity.hook(this.$popup, 'translateX', '-50%');

        this.$el[0].style.display = 'block';
        this.$overlay[0].style.opacity = 1;

        return $.Velocity.animate(this.$popup, {
            opacity: [1, 'linear'],
            translateY: ['-50%', 'easeOutCubic'],
            translateX: ['-50%', 'easeOutCubic'],
        }, _.extend({duration: 500}, options))
    },

    deactivate (options) {
        var self = this;
        return $.Velocity.animate(this.$popup, {
                opacity: [0, 'linear'],
                translateY: [ '-40%', 'easeOutCubic'],
                translateX: ['-50%', 'easeOutCubic']
            }, _.extend({
                duration: 500,
                complete() {
                    self.$el[0].style.display = 'none';
                    self.$overlay[0].style.opacity = 0;
                    scrollLock.enablePageScroll();
                }
            }, options))
    }
})

export default ApplicationPopup



// WEBPACK FOOTER //
// ./assets/app/front/components/ApplicationPopup/ApplicationPopup.js